import {ICON_TYPES} from '@frontend/ui-kit/Components/Icon';
import SidebarItem from '../SidebarItem';
import {ROUTES} from '../../../constants';
import styles from './index.module.scss';

const SIDEBAR_ITEMS = [
    {
        title: 'Benefits\nAnalysis',
        icon: ICON_TYPES.benefits,
        path: ROUTES.benefitsAnalysis
    },
    {
        title: 'Client\nManagement',
        icon: ICON_TYPES.people,
        path: ROUTES.clientManagement
    }
];

const Sidebar = () => {
    return (
        <div className={styles['sidebar']}>
            <div className={styles['sidebar-main']}>
                {SIDEBAR_ITEMS.map(item => (
                    <SidebarItem key={item.path} {...item}/>
                ))}
            </div>
        </div>
    );
};

export {Sidebar as TestableSidebar};
export default Sidebar;
